import request from "@/util/axios";

// 共享变量
var _JDJL_order_tmp_ = {};

const JDJL_get_order = function (JDJL_orderId) {
  return new Promise(function (resolve, reject) {
    var formData = new FormData();
    formData.append("JDJL_orderId", JDJL_orderId);

    // 查询待支付订单信息 主要是金额
    request.post("/mall/rc-jd-jl-order-fee", formData).then((res) => {
      budo_log.info("#14 rc-jd-jl-order-fee, res=", res);

      if (res && res.data) {
        res.data.orderFee = Number(res.data.totalMoney) * 100;

        _JDJL_order_tmp_ = res.data;
        resolve(res.data);
        return;
      }

      reject("rc-jd-jl-order-fee err");
    });
  });
};

const JDJL_order_info_for_pay = function (cards) {
  budo_log.info("#30 _JDJL_order_tmp_=", _JDJL_order_tmp_, "cards=", cards);

  _JDJL_order_tmp_.cardList = JSON.parse(JSON.stringify(cards));
  _JDJL_order_tmp_.cardList.forEach((e) => {
    e.cardUseType = e.useType;
    e.quantity = e.useQuantity; // 这张卡使用了多少
  });

  _JDJL_order_tmp_.goodsList = [];

  _JDJL_order_tmp_.orderType = "JDJL";
  _JDJL_order_tmp_.goodsType = "JDJL";
  _JDJL_order_tmp_.tradeno = _JDJL_order_tmp_.orderId;
  _JDJL_order_tmp_.expressFee = Number(_JDJL_order_tmp_.freight) * 100;

  _JDJL_order_tmp_.cardMoney = _JDJL_order_tmp_.cardList
    .map((e) => e.quantity)
    .reduce((sum, quantity) => sum + quantity, 0);
  _JDJL_order_tmp_.wxPayFee =
    _JDJL_order_tmp_.orderFee - _JDJL_order_tmp_.cardMoney;

  return _JDJL_order_tmp_;
};

export { JDJL_get_order, JDJL_order_info_for_pay };
